import React from 'react';
import moment from 'moment';
import sAction from 'sAction';
import ResetPassRequest from 'ROOT/views/portal/components/login/ResetPassRequest';
import LoginForm from 'ROOT/views/portal/components/login/LoginForm';
import ResetPass from 'ROOT/views/portal/components/login/ResetPass';
import Login_orig from 'ROOT/src/components/login/login';
import CarouselWidget from './CarouselWidget';
import RequestAccess from './RequestAccess';

export default class Login extends Login_orig {
    constructor() {
        super();
        this.state = {
            backgroundImages: sAction.param.portalLoginImages,
            actualBgImage: sAction.param.portalLoginImages[0],
            actualBgImageIndex: 0,
            prevBgImage: sAction.param.portalLoginImages[0],
            updatingBgImage: false,
        };

        if (this.state.backgroundImages && this.state.backgroundImages.length > 0) {
            setInterval(() => {
                this.changeBackgroundImage();
            }, 6000);
        }
    }

    componentDidMount() {
        if (localStorage.getItem('portalLoginAs') != 'true') {
            sAction.dataSet('conf/alertMessage/show', false);
        }
    }

    changeBackgroundImage() {
        const {backgroundImages, actualBgImageIndex, actualBgImage} = this.state;
        let nextBgImageIndex = actualBgImageIndex + 1;
        if (nextBgImageIndex >= backgroundImages.length) {
            nextBgImageIndex = 0;
        }
        const nextBgImage = backgroundImages[nextBgImageIndex];
        if (nextBgImage) {
            this.setState({
                prevBgImage: actualBgImage,
            });
            setTimeout(() => {
                this.setState({
                    actualBgImage: nextBgImage,
                    actualBgImageIndex: nextBgImageIndex,
                    updatingBgImage: true,
                });
            }, 800);
        }
        setTimeout(() => {
            this.setState({updatingBgImage: false});
        }, 1000);
    }

    goToRequestAccess() {
        window.location.hash = '#login/requestAccess';
        this.setState({
            url: '#login/requestAccess',
        });
    }

    goToLogin() {
        window.location.hash = '#login';
        this.setState({
            url: '#login',
        });
    }

    goToResetPassword() {
        window.location.hash = '#login/resetPassword';
        this.setState({
            url: '#login/resetPassword',
        });
    }

    render() {
        const hasBgImages = sAction.param.showLoginBackgroundImages;
        let backgroundImage;
        let renderVideo = true;
        if (hasBgImages) {
            backgroundImage = (<div
                id={'loginPageBackground'}
                style={{backgroundImage: this.state.backgroundImage}}
            />);
        } else {
            backgroundImage = '';
        }

        let loginWindow;
        if (window.location.hash === '#login/resetPassword' || window.location.hash === '#login/resetPassword/') {
            loginWindow = (
                <ResetPassRequest
                    goToLogin={() => this.goToLogin()}
                />
            );
        } else if (window.location.hash.includes('#login/resetPassword/')) {
            const urlArray = window.location.hash.split('/');
            if (urlArray[1] == 'resetPassword' && urlArray[2]) {
                loginWindow = (
                    <ResetPass
                        goToLogin={() => this.goToLogin()}
                    />
                );
            }
        } else {
            loginWindow = (
                <LoginForm
                    goToResetPassword={() => this.goToResetPassword()}
                    goToRequestAccess={() => this.goToRequestAccess()}
                    redirect={this.props.redirect}
                />
            );
        }
        switch (window.location.hash) {
            // Přihlašovací okno
            case '#login':
            case '#login/':
                // default:
                loginWindow = (
                    <LoginForm
                        goToResetPassword={() => this.goToResetPassword()}
                        goToRequestAccess={() => this.goToRequestAccess()}
                        redirect={this.props.redirect}
                    />
                );
                break;
            // Žádost o reset hesla
            case '#login/resetPassword':
            case '#login/resetPassword/':
                loginWindow = (
                    <ResetPassRequest
                        goToLogin={() => this.goToLogin()}
                    />
                );
                break;
            case '#login/requestAccess':
            case '#login/requestAccess/':
                loginWindow = (
                    <RequestAccess
                        goToLogin={() => this.goToLogin()}
                    />
                );
                renderVideo = false;
                break;
            // Ostatní případy + reset hesla dle tokenu
            default:
                const urlArray = window.location.hash.split('/');
                if (urlArray[1] == 'resetPassword' && urlArray[2]) {
                    loginWindow = (
                        <ResetPass
                            goToLogin={() => this.goToLogin()}
                        />
                    );
                    break;
                }
        }

        switch (this.state.url) {
            // Přihlašovací okno
            case '#login':
            case '#login/':
                // default:
                loginWindow = (
                    <LoginForm
                        goToResetPassword={() => this.goToResetPassword()}
                        goToRequestAccess={() => this.goToRequestAccess()}
                        redirect={this.props.redirect}
                    />
                );
                break;
            // Žádost o reset hesla
            case '#login/resetPassword':
            case '#login/resetPassword/':
                loginWindow = (
                    <ResetPassRequest
                        goToLogin={() => this.goToLogin()}
                    />
                );
                break;
            case '#login/requestAccess':
            case '#login/requestAccess/':
                loginWindow = (
                    <RequestAccess
                        goToLogin={() => this.goToLogin()}
                    />
                );
                renderVideo = false;
                break;
        }

        return (
            <div>
                <div id="loginPageContainer">
                    <div className="navBarLogin">
                        <div className="navBarContainer">
                            <div className="navBarLogo">
                                <a href='#login' onClick={() => this.goToLogin()}><img src="img/aon_logo.svg" alt="AON"/></a>
                            </div>
                            <div className="navBarMenu">
                                <div className="navBarMenuItem">
                                    <a href="https://www.aon.com/reinsurance/impact-forecasting/default.jsp">Impact Forecasting</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="https://www.aon.com/reinsurance/catastropheinsight/default">Catastrophe Insight</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="https://www.aon.com/en/insights/events/impact-forecasting">Nat Cat Revealed</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="mailto:ifsupport@aon.com">Contact Us</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contentContainer">
                        <div className={'loginContainerGrid' + (!renderVideo ? ' singleCenter' : '')}>
                            <div className="loginFormContainer">
                                {loginWindow}
                            </div>
                            { renderVideo &&
                                <div className="loginVideoContainer">
                                    <CarouselWidget />
                                    {/* fade from one image to next */}
                                    <div className="loginImagesCarrousel">
                                        <img src={this.state.actualBgImage}
                                            className={'loginImg next ' + (!this.state.updatingBgImage ? ' nextFadeIn' : '')}
                                        />
                                        <img src={this.state.prevBgImage}
                                            className="loginImg prevFadeOut"
                                        />
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="loginPageFooter">
                            <div className="loginPageFooterContainer">
                                <div className="footerCopyright footerItem">
                                    <a href='https://www.aon.com/en/'>Products & Services</a>
                                    <a href='http://ir.aon.com/'>Investor Relations</a>
                                    <a href='http://www.aon.com/about-aon/careers.jsp'>Careers</a>
                                    <a href='https://www.aon.com/about-aon/privacy.jsp'>Privacy Policy</a>
                                    <a href='http://www.aon.com/about-aon/cookies.jsp'>Cookie Notice</a>
                                </div>
                                <div className="footerSocials footerItem">
                                    <a className="iconfab-facebook" href='https://www.facebook.com/Aonplc/'></a>
                                    <a className="iconfab-linkedin" href='https://www.linkedin.com/showcase/reinsurance-aon'></a>
                                    <a className="iconfab-twitter" href='https://twitter.com/aon_plc'></a>
                                </div>
                                <div className="footerCopyrightRights footerItem">
                                    <p>© {moment().format('YYYY')} Aon. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/*
                <div id="loginPage">
                    <div id="loginContentContainer">
                        <div id="loginContainer" style={hasBgImages ? {boxShadow: 'none'} : {}}>
                            <img className="loginContainerLogo" src={sAction.param.companyLogoDark} />

                            <div className="loginContent">
                                {loginWindow}
                            </div>
                        </div>

                        <div className="videoContainer">
                            <div className="videoContainerOverlay"></div>
                            {sAction.param.loginVideo &&
                            <video autoPlay loop muted className="videoPlayer">
                                <source src={sAction.param.loginVideo} type="video/mp4" />
                            </video>}
                            <img src={sAction.param.loginImage} className="videoContainerBgImg" />
                        </div>

                    </div>
                </div> */}
            </div>
        );
    }
}
